<div class="auth">
  <aside class="auth-art" aria-hidden="true">
    <a class="auth-art-logo" routerLink="/home" tabindex="-1">
      <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="" />
    </a>
    <p class="auth-art-tagline">{{ tagline }}</p>
  </aside>

  <main class="auth-main">
    <a class="auth-logo" routerLink="/home">
      <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler home" />
    </a>

    <div class="auth-card">
      <ng-content></ng-content>
    </div>

    <footer class="auth-legal">
      <a routerLink="/terms-of-service">Terms</a>
      <span aria-hidden="true">·</span>
      <a routerLink="/privacy-policy">Privacy</a>
      <span aria-hidden="true">·</span>
      <a href="mailto:support@worldtumbler.com">Help</a>
      <span class="auth-legal-copy">© {{ year }} WorldTumbler</span>
    </footer>
  </main>
</div>
